/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion */
import { trackEvent } from '@kcd/event-tracker';

import { ShoebillImage } from '~/components/Image';
import { OFFERS_ROUTER, VENDORS_ROUTER } from '~/constants/router';
import CouponDiscountedPrice from '~/domains/products/components/CouponDiscountedPrice';
import { openModal } from '~/utils/mobileApp';
import { MARKET_BASE_URL } from '~/utils/url';

import type { HomeShowcaseListType } from './helper';

type Props = {
  selectedShowcase: HomeShowcaseListType[number];
};

export function SelectedShowcase({
  selectedShowcase: { productResponse, type, code, displayLeftImageUrl },
}: Props) {
  const onImgClick = () => {
    trackEvent('clicked banner in 마켓/홈_상단', {
      clicked_area: 'main_banner',
      showcase_code: code,
    });

    const url =
      type === 'showcase'
        ? OFFERS_ROUTER.showcase(code!)
        : OFFERS_ROUTER.showcaseGroup(code!);
    openModal({
      url: `${MARKET_BASE_URL}${url}`,
    });
  };

  const onProductClick = () => {
    if (productResponse) {
      trackEvent('clicked banner in 마켓/홈_상단', {
        clicked_area: 'product_info',
        showcase_code: code,
      });

      const url = VENDORS_ROUTER.productDetail(
        productResponse.vendorId!,
        productResponse.offerId!,
      );

      openModal({
        url: `${MARKET_BASE_URL}${url}`,
      });
    }
  };

  return (
    <div className="flex size-full flex-col">
      {displayLeftImageUrl && (
        <ShoebillImage
          width={480}
          height={480}
          role="presentation"
          onClick={onImgClick}
          className="size-full flex-1 overflow-hidden rounded-t-16 border border-b-0 border-solid border-02 object-cover"
          src={displayLeftImageUrl}
          alt="쇼케이스이미지"
          fetchPriority="high"
        />
      )}

      {productResponse && (
        <div
          className="flex gap-8 rounded-b-16 border border-t-0 border-solid border-02 p-8"
          role="presentation"
          onClick={onProductClick}
        >
          <div className="aspect-[1/1] shrink-0 grow-0 basis-[60px] overflow-hidden">
            <div className="relative size-[60px] overflow-hidden rounded-16 border border-solid border-screen-02">
              <ShoebillImage
                width={60}
                height={60}
                className="object-contain"
                src={productResponse.mainImages![0]}
              />
            </div>
          </div>
          <div className="flex flex-1 flex-col overflow-hidden">
            <p className="truncate">{productResponse.productName}</p>
            <CouponDiscountedPrice {...productResponse} reverse />
          </div>
        </div>
      )}
    </div>
  );
}
